import React, {useState} from 'react';
import {BoxSeam, Truck, TruckFlatbed, TruckFront} from 'react-bootstrap-icons';

export const getTruckTypeIconVariant = (truckType) => {
    const identity = [truckType?.type, truckType?.title, truckType?.driver_truck_type]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();

    if (identity.includes('flatbed') || identity.includes('flatdeck') || identity.includes('moffett')) return 'flatbed';
    if (identity.includes('pickup')) return 'pickup';
    if (identity.includes('cube') || identity.includes('box')) return 'cube';
    if (identity.includes('cargo') || identity.includes('van')) return 'van';
    return 'truck';
};

const fallbackIcons = {
    pickup: Truck,
    flatbed: TruckFlatbed,
    cube: BoxSeam,
    van: TruckFront,
    truck: TruckFront,
};

const TruckTypeIcon = ({truckType, className = ''}) => {
    const FallbackIcon = fallbackIcons[getTruckTypeIconVariant(truckType)];
    const iconUrl = truckType?.icon;
    const [failedIconUrl, setFailedIconUrl] = useState(null);
    const showCustomIcon = Boolean(iconUrl) && failedIconUrl !== iconUrl;

    return (
        <span className={`dispatch-truck-type-icon ${className}`.trim()} aria-hidden="true">
            {showCustomIcon ? (
                <img
                    key={iconUrl}
                    data-testid="truck-type-custom-icon"
                    src={iconUrl}
                    alt=""
                    onError={() => setFailedIconUrl(iconUrl)}
                />
            ) : (
                <FallbackIcon data-testid="truck-type-fallback-icon"/>
            )}
        </span>
    );
};

export default TruckTypeIcon;
